import { useContext, useRef } from 'react';

import styles from './PD_FileComponent.module.css';

import { ProjectDetailsContext } from "../../../contexts/projectDetailsContext";
import { GlobalContext } from "../../../contexts/globalContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

const PD_FileComponent = ({ file, onClickFile }) => {
    
    const deleteRef = useRef();

    const { selectedRefTypeForFiles, selectedTopicIdRef, socketRef, selectedProject, appWidth, appHeight, } = useContext(GlobalContext);
    const { setDeleteClicked } = useContext(ProjectDetailsContext);

    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    const handleDeleteFile = () => {
        socketRef.current.emit(
            "PROJECT_DELETE_DOCUMENT",
            {
                parentId: selectedTopicIdRef.current,
                refType: selectedRefTypeForFiles || "Topic",
                projectFileId: file._id,
                projectId: selectedProject._id
            },
            () => {
                setDeleteClicked(false);
            }
        );
    };

    const icon = (() => {
        if (file.docsFile.type.includes("image")) {
            return "file-image";
        } else if (file.docsFile.type.includes("video")) {
            return "file-video";
        } else if (file.docsFile.type.includes("pdf")) {
            return "file-pdf";
        } else if (file.docsFile.type.includes("word")) {
            return "file-word";
        } else if (file.docsFile.type.includes("excel")) {
            return "file-excel";
        } else if (file.docsFile.type.includes("site")) {
            return "file-export";
        } else {
            return "file-lines";
        }
    })();

    const handleDelete = (e) => {
        e.stopPropagation();
        if (!deleteRef.current) return;

        const rect = deleteRef.current.getBoundingClientRect();

        let x = rect.x
        let y = rect.y

        if(x / oxDivider - 1024 + 739 > appWidth){
            x = (appWidth - 760 ) * oxDivider
        }

        if(y / oyDivider + 255 > appHeight){
            y = (appHeight - 275) * oyDivider
        }

        setDeleteClicked({
            shown: true,
            funct: handleDeleteFile,
            name: "File",
            x: x + 90,
            y: y,
            onClose: () => setDeleteClicked(),
        });
    };

    const createImage = () => {
        return process.env.REACT_APP_CMS_URL + file.docsFile.path
    };
    
    return (
        <div key={file._id} className={styles.element}>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                <div className={styles.info}>
                    <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas[icon]} />

                    <div className={styles.participantDetails}>
                        <div className={styles.fileName} onClick={onClickFile}>{file.docsFile.name}</div>
                        <div className={styles.participantDescription}>
                            Added by:
                            <div className={styles.participantRole}>{file.addedBy?.name}</div>
                        </div>
                    </div>
                </div>
            </div>
            {file.docsFile.type.includes("image") && <img className={styles.image} alt='image' src={createImage()} />}
            <FontAwesomeIcon
                    ref={deleteRef}
                    className={styles.iconButton}
                    style={{ right: 50, top: 70, fontSize: 32 }}
                    icon={byPrefixAndName.fal["trash"]}
                    onClick={(e) => { handleDelete(e) }}
                />
        </div>
    );
};

export default PD_FileComponent;
